/* eslint-disable no-console */
/* eslint-disable max-len */

export const scoreHasChanged = (score1, score2) => {
  if (!score1 && !!score2) return true;
  if (!score2 && !!score1) return true;
  if (!score1 && !score2) return false;
  if (score1.name !== score2.name) return true;
  if (score1.significance !== score2.significance) return true;
  if (Array.isArray(score1.scoreCard) !== Array.isArray(score2.scoreCard)) {
    return true;
  }
  if (Array.isArray(score1.scoreCard)) {
    for (let i = 0; i < score1.scoreCard.length; i++) {
      const item1 = score1.scoreCard[i];
      const item2 = score2.scoreCard[i];
      if (item1.score !== item2.score) return true;
      if (item1.definition !== item2.definition) return true;
    }
    if (score1.scoreCard.length !== score2.scoreCard.length) return true;
  }
  return false;
};

const getNumberString = input => {
  switch (input) {
    case 0:
      return '1st';
    case 1:
      return '2nd';
    case 2:
      return '3rd';
    case 3:
      return '4th';
    case 4:
      return '5th';
  }
  return '';
};

export const getScoreValidationErrors = score => {
  const errors = {};
  if (typeof score.name !== 'string' || score.name === '') {
    errors.name = 'Name is required';
  } else if (score.name.length < 3) {
    errors.name = 'Significance must be at least 3 characters';
  }
  if (typeof score.significance !== 'string' || score.significance === '') {
    errors.significance = 'Significance is required';
  } else if (score.significance.length < 10) {
    errors.significance = 'Significance must be at least 10 characters';
  }
  if (!Array.isArray(score.scoreCard)) {
    errors.scoreCard = 'Scores are required';
  } else {
    score.scoreCard.forEach((score, index) => {
      if (typeof score.score !== 'number') {
        errors[`score-${index}`] = 'Score number is required';
      } else if (![0, 1, 2, 3, 4, 6, 8].includes(score.score)) {
        errors[`score-${index}`] = 'Score must be one of 0,1,2,3,4,6,8';
      }
      if (typeof score.definition !== 'string' || score.definition === '') {
        errors[`score-${index}`] =
          `Definition on ${getNumberString(index)} score is required`;
      } else if (score.definition.length < 10) {
        errors[`score-${index}`] =
        `Definition on ${getNumberString(index)} must be at least 10 characters`;
      }
    });
  }
  return errors;
};

export const getElementFactors = (element, scoreDefinitions) => {
  return Object.keys(scoreDefinitions)
    .filter(key => scoreDefinitions[key].category === element);
};

export const getScoreCardText = (name, score, scoreDefinitions) => {
  try {
    return scoreDefinitions[name].scoreCard.filter(
      rating => rating.score === score
    )[0].definition;
  } catch (error) {
    console.log(`no definition found in scoreDefinitions for attribute ${name} and score ${score}`);
    return '';
  }
};

export const getSignificance = (attribute, scoreDefinitions) => {
  try {
    return scoreDefinitions[attribute].significance;
  } catch (error) {
    console.log(`no significance text found in scoreDefinitions for attribute ${attribute}`);
    return '';
  }
};

export const getScoreCard = (attribute, scoreDefinitions) => {
  try {
    const scoreCard = scoreDefinitions[attribute].scoreCard;
    if (typeof scoreCard === 'undefined') {
      console.log(`no scoreCard found in scoreDefinitions for attribute ${attribute}`);
      return [];
    }
    return scoreCard;
  } catch (error) {
    console.log(`no scoreCard found in scoreDefinitions for attribute ${attribute}`);
    return [];
  }
};

export const getCategory = (attribute, scoreDefinitions) => {
  try {
    return scoreDefinitions[attribute].category;
  } catch (error) {
    console.log(`no category found in scoreDefinitions for attribute ${attribute}`);
    return '';
  }
};

export const getName = (attribute, scoreDefinitions) => {
  try {
    return scoreDefinitions[attribute].name;
  } catch (error) {
    console.log(`no name found in scoreDefinitions for attribute ${attribute}`);
    return '';
  }
};

export const gbiElements = ['production', 'eating', 'environment'];

export const factorElementDefinitions = {
  production: 'GoodBeef Index assesses how an animal is reared, which affects eating quality and environmental impact',
  eating: 'GoodBeef Index assesses feed sources, marbling, fat cover, breed and other factors, which determine good quality beef',
  environment: 'GoodBeef Index clarifies for farmers, consumers and the general public why good beef is good for the environment'
};

export const getFactorDef = factor => {
  return factorElementDefinitions[factor] || '';
};

const GBIShortGrades = {
  Ungraded: '',
  Standard: 'Indicates an animal produced for the large scale retail trade to the EU standard “R3 or R4L” beef classification',
  Superior: 'Points to beef from a cross bred cow, suckled until weaning and grazed outdoors on grass',
  Classic: 'Signals a high-class beef animal with good marbling and fat cover, grass fed and environmentally sensitive',
  Prime: 'Pure suckler beef in the top 2-3% for eating quality and environmentally beneficial cattle rearing',
  Supreme: 'Combines regenerative grassland farming with flavourful pure-bred suckler beef - for a new world-class standard'
};

export const GBIGrades = ['Supreme', 'Prime', 'Classic', 'Superior', 'Standard'];

export const getGradeFromScore = score => {
  if (score > 110) return 'Supreme';
  else if (score >= 100) return 'Prime';
  else if (score >= 90) return 'Classic';
  else if (score >= 80) return 'Superior';
  else if (score >= 70) return 'Standard';
  return 'Ungraded';
};

export const getGrade = (
  productionData, eatingData, environmentData, scoreDefinitions
) => {
  const production = JSON.parse(JSON.stringify(productionData));
  const eating = JSON.parse(JSON.stringify(eatingData));
  const environment = JSON.parse(JSON.stringify(environmentData));
  let score = 0;
  Object.keys(production).forEach(key => {
    if (scoreDefinitions[key] &&
      scoreDefinitions[key].category === 'production') {
      if (typeof production[key] === 'number') {
        score += production[key];
      } else if (typeof production[key].score === 'number') {
        score += production[key].score;
        production[key] = production[key].score;
      }
    }
  });
  Object.keys(eating).forEach(key => {
    if (scoreDefinitions[key] &&
      scoreDefinitions[key].category === 'eating') {
      if (typeof eating[key] === 'number') {
        score += eating[key];
      } else if (typeof eating[key].score === 'number') {
        score += eating[key].score;
        eating[key] = eating[key].score;
      }
    }
  });
  Object.keys(environment).forEach(key => {
    if (scoreDefinitions[key] &&
      scoreDefinitions[key].category === 'environment') {
      if (typeof environment[key] === 'number') {
        score += environment[key];
      } else if (typeof environment[key].score === 'number') {
        score += environment[key].score;
        environment[key] = environment[key].score;
      }
    }
  });
  return getGradeFromScore(score);
  // if (score >= 110 &&
  //   eating.breed >= 3 &&
  //   eating.homeBred === 4 &&
  //   eating.texture === 4 &&
  //   environment.pastureVsGrain === 4) {
  //   return 'Supreme';
  // } else if (score >= 100 &&
  //   environment.pastureVsGrain >= 2 &&
  //   eating.breed >= 3 &&
  //   eating.flavour >= 3 &&
  //   eating.fatCover >= 3 &&
  //   production.health === 8) {
  //   return 'Prime';
  // } else if (score >= 90 &&
  //   eating.breed >= 2 &&
  //   environment.pastureVsGrain >= 2 &&
  //   eating.flavour >= 2 &&
  //   eating.fatCover >= 2) {
  //   return 'Classic';
  // } else if (score >= 80 &&
  //   production.health >= 6 &&
  //   environment.pastureVsGrain >= 2 &&
  //   eating.homeBred >= 2 &&
  //   eating.breed >= 1) {
  //   return 'Superior';
  // } else if (score >= 70) return 'Standard';
};

export const getShortGradeDescription = grade => {
  return GBIShortGrades[grade];
};

/**
 * Calculate a gbi score from a db animal.
 * validates scores against score definitions.
 * @param {object} animal from db
 */
export const calculateScore = (animal, scoreDefinitions) => {
  let score = 0;
  try {
    const production = JSON.parse(JSON.stringify(animal.production));
    const eating = JSON.parse(JSON.stringify(animal.eating));
    const environment = JSON.parse(JSON.stringify(animal.environment));
    Object.keys(production).forEach(key => {
      if (scoreDefinitions[key] &&
        scoreDefinitions[key].category === 'production') {
        if (typeof production[key] === 'number') {
          score += production[key];
        } else if (typeof production[key].score === 'number') {
          score += production[key].score;
          production[key] = production[key].score;
        }
      }
    });
    Object.keys(eating).forEach(key => {
      if (scoreDefinitions[key] &&
        scoreDefinitions[key].category === 'eating') {
        if (typeof eating[key] === 'number') {
          score += eating[key];
        } else if (typeof eating[key].score === 'number') {
          score += eating[key].score;
          eating[key] = eating[key].score;
        }
      }
    });
    Object.keys(environment).forEach(key => {
      if (scoreDefinitions[key] &&
        scoreDefinitions[key].category === 'environment') {
        if (typeof environment[key] === 'number') {
          score += environment[key];
        } else if (typeof environment[key].score === 'number') {
          score += environment[key].score;
          environment[key] = environment[key].score;
        }
      }
    });
  } catch (error) { /* */ }
  return score;
};

export const calculateElementScore = (animal, element, scoreDefinitions) => {
  let score = 0;
  try {
    const data = JSON.parse(JSON.stringify(animal[element]));
    Object.keys(data).forEach(key => {
      if (scoreDefinitions[key] &&
        scoreDefinitions[key].category === element) {
        if (typeof data[key] === 'number') {
          score += data[key];
        } else if (typeof data[key].score === 'number') {
          score += data[key].score;
          data[key] = data[key].score;
        }
      }
    });
  } catch (error) { /* */ }
  return score;
};
